const mEditionMapPath = {
  mEditionMapPath: {
    alerts: {
      updateContenidoJerarquiasNodos: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El orden de los contenidos fue actualizado exitosamente.'
      }
    },

    buttonSecondary: {
      createNodeText: 'Nuevo'
    },

    quote: {
      firstText: 'Aún no tienes versiones de contenido generadas para tu mapa.',
      secondText: 'Aquí puedes crear versiones y agrupar los diferentes contenidos.',
      thirdText: 'Aún no tienes caminos creados en tu mapa.',
      fourthText: 'Aquí puedes crear caminos y utilizar el editor para agregar textos, audios, documentos, videos y enlaces.'
    }
  }
}

export default mEditionMapPath
